<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-card>
          <v-form>
            <v-card-title>
              <v-icon large color="black">build</v-icon>
              <h3>Connect Web Application Console</h3>
            </v-card-title>
            <v-card-text>
              <br />
              <h2>Switch User</h2>
              <v-text-field v-model="switchTargetUserEmail" label="Email" required />
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn type="submit" color="error" @click.stop.prevent="switchUser">Switchする!!（取扱注意）</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'application-console',
  mounted: {},
  data() {
    return {
      switchTargetUserEmail: undefined,
    }
  },
  methods: {
    switchUser() {
      this.$store.dispatch('authImpersonate', this.switchTargetUserEmail)
    },
  },
}
</script>
